import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EvadocCuestionarioPregunta } from '../model/evadoc-cuestionario-pregunta';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EvadocCuestionarioPreguntaService {

  url = `${environment.host}/api/cuestionario-pregunta`;

  constructor(private http: HttpClient) { }

  ObtenerPreguntas(cuestionario: number): Observable<EvadocCuestionarioPregunta[]> {
    return this.http.get<EvadocCuestionarioPregunta[]>(`${this.url}/${cuestionario}`).pipe(catchError(error => {
      console.log('Error service CuestionarioPregunta-obtenerPreguntas', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }
}
